import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export const defaultPreset = {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '{indigo.950}',
          inverseColor: '#ffffff',
          hoverColor: '{indigo.900}',
          activeColor: '{indigo.800}',
        },
        highlight: {
          background: '{indigo.950}',
          focusBackground: '{indigo.700}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
    },
  },
}
export const FMPreset = definePreset(Aura, defaultPreset)
